{
  "version": 1,
  "titles": [
    { "id": "rookie", "nameKey": "profile.titleRookie", "minHighestLevel": 1 },
    { "id": "master", "nameKey": "profile.titleMaster", "minHighestLevel": 5 },
    { "id": "legend", "nameKey": "profile.titleLegend", "minHighestLevel": 10 }
  ]
}
